// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var ClientID = function (x) {
    return x;
};
var tsBridgeClientID = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("ClientID")("__brandClientID"));
    }
};
var writeClientID = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showClientID = Data_Show.showString;
var readClientID = Simple_JSON.readString;
var ordClientID = Data_Ord.ordString;
var newtypeClientID = {
    Coercible0: function () {
        return undefined;
    }
};
var makeClientID = ClientID;
var eqClientID = Data_Eq.eqString;
export {
    ClientID,
    makeClientID,
    unwrap,
    newtypeClientID,
    eqClientID,
    ordClientID,
    showClientID,
    readClientID,
    writeClientID,
    tsBridgeClientID
};
//# sourceMappingURL=index.js.map
